<template>
  <v-layout class="pt-4">
    <table class="statsTable selectable">
      <tr>
        <th class="primary" rowspan="3">
          {{ (component && component.label) || '' }}
        </th>
      </tr>
      <tr>
        <th
          class="primary"
          :colspan="tableDataHasRemainder ? numColumns + 1 : numColumns"
          v-if="numColumns > 0"
        >
          {{ columns.label }}
        </th>
        <th class="primary" rowspan="2">{{ $t('common.Total') }}</th>
      </tr>
      <tr>
        <div
          style="display: contents"
          v-for="col in columnOptions"
          :key="col.value"
        >
          <th class="primary">{{ col.text }}</th>
        </div>
        <th class="primary" v-if="tableDataHasRemainder">
          {{ $t('common.NoRegistry') }}
        </th>
      </tr>
      <tr v-for="row in tableData" :key="row.id">
        <td>{{ row.label }}</td>
        <div
          style="display: contents"
          v-for="(cell, index) in row.cells"
          :key="row.id + '.' + index"
        >
          <td>{{ cell }}</td>
        </div>
        <!-- </div> -->
        <td v-if="tableDataHasRemainder">{{ row.remainder }}</td>
        <td>{{ row.total }}</td>
      </tr>
    </table>

    <!-- <code> {{ component }} </code> -->
  </v-layout>
</template>

<script>
import specialtyFetcher from '../../mixins/specialtyFetcher'
import statistics from '@/statistics'
import { LogMapper } from '@/statistics/mappers/base'

export default {
  mixins: [specialtyFetcher],
  props: {
    logs: {
      type: Array,
      required: true
    },
    component: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getChecker(component) {
      const id = (component || {}).id
      if (this.mapper.components[id]) {
        return this.mapper.components[id].checker
      }
      return LogMapper.checker
    }
  },
  computed: {
    rowChecker() {
      return this.getChecker(this.component)
    },
    columnChecker() {
      return this.getChecker(this.columns)
    },
    specialty() {
      return this.$store.getters.specialty
    },
    mapper() {
      return statistics[this.specialty] || LogMapper
    },
    rowOptions() {
      return this.mapper.getOptions(this.component, this.logs)
    },
    columnOptions() {
      return this.mapper.getOptions(this.columns, this.logs)
    },
    numColumns() {
      return this.columnOptions.length
    },
    tableDataHasRemainder() {
      return (
        this.columnOptions.length > 0 &&
        this.tableData[this.tableData.length - 1].remainder > 0
      )
    },
    tableData() {
      const tableData = []

      for (let r = 0; r < this.rowOptions.length; r++) {
        const rowOption = this.rowOptions[r]
        const rowData = {
          id: rowOption.value,
          label: rowOption.text,
          total: 0,
          remainder: 0,
          cells: []
        }

        for (let c = 0; c < this.columnOptions.length; c++) {
          const columnOption = this.columnOptions[c]
          const cellTotal = this.logs.filter(
            log =>
              this.rowChecker(log, this.component.id, rowOption) &&
              this.columnChecker(log, this.columns.id, columnOption)
          ).length
          rowData.cells.push(cellTotal)
        }

        const rowTotal = this.logs.filter(log =>
          this.rowChecker(log, this.component.id, rowOption)
        ).length

        rowData.remainder = rowTotal - rowData.cells.reduce((a, b) => a + b, 0)

        rowData.total = rowTotal
        if (rowTotal > 0) {
          tableData.push(rowData)
        }
      }

      const totalRow = {
        id: 'total',
        label: 'Total',
        total: 0,
        remainder: 0,
        cells: []
      }
      for (let c = 0; c < this.columnOptions.length; c++) {
        const columnOption = this.columnOptions[c]
        const cellTotal = this.logs.filter(log =>
          this.columnChecker(log, this.columns.id, columnOption)
        ).length
        totalRow.cells.push(cellTotal)
      }
      totalRow.total = tableData.reduce((sum, row) => sum + row.total, 0)

      totalRow.remainder =
        totalRow.total - totalRow.cells.reduce((a, b) => a + b, 0)

      tableData.push(totalRow)

      return tableData
    }
  }
}
</script>
<style>
.selectable {
  -webkit-user-select: text !important;
  user-select: text !important;
}
</style>
